import { useEffect, useState } from "react";
import style from "../components-css/CustomHover.module.css";
import { useDispatch, useSelector } from "react-redux";
import { editorActions } from "../../store/editor";

// import checkMarkBlack from "../assets/checkMarkBlack.png"
// import deleteIcon from "../assets/previewDelete2x.png"
// import typeFaceIcon from "../assets/typeFaceIcon.png"
// import sortIcon from "../assets/sortIcon.png"
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { get } from "lodash";

type CustomHoverProps = {
  valueKey: string;
  isShare: boolean;
  isEdit: boolean;
  showDeleteIcon?: boolean;
  clickEdit: () => void;
  clickClose: () => void;
  defaultStyle?: any;
  clickSave: (data: any) => void;
};

function CustomHover(props: CustomHoverProps) {
  const { showDeleteIcon = true } = props;
  const dispatch = useDispatch();

  const fontFamilyArr = [
    "Ak-bold",
    "Ak-Light",
    "Ak-Medium",
    "Ak-Regular",
    "SF-Bold",
    "SF-Medium",
    "SF-Regular",
    "SF-Light",
  ];

  const [defaultStyle, setDefaultStyle] = useState(props.defaultStyle);

  const [showHover, setShowHover] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const [selectedIconBox, setSelectedIconBox] = useState("");

  const showEditArrStore: [string] = useSelector(state => get(state, "editor.showEditArrStore", [""]));
  const setShowEditArrStore = (val: any) => {
    dispatch(editorActions.setShowEditArrStore(val));
  };

  const isStaticMode = useSelector(state => get(state, "editor.isStaticMode", true));

  const onMouseLeave = () => {
    // 编辑状态下移开保持编辑
    if (showEdit) return;
    setShowHover(false);
    setShowEdit(false);
  };
  const onMouseOver = () => {
    if (props.isShare) return;
    setShowHover(true);
  };

  // 进入编辑状态
  const clickEdit = (e: any) => {
    if (isStaticMode) return;
    e.stopPropagation();
    setShowEdit(true);
    props.clickEdit();
  };

  // 退出编辑
  const clickClose = (e: any) => {
    if (isStaticMode) return;
    e.stopPropagation();
    setShowEdit(false);
    setShowHover(false);
    setSelectedIconBox("");
    props.clickClose();
  };

  // 是否显示虚线框
  const hideAndDisplay = (key: boolean) => {
    return key ? style["display-box"] : style["hide-box"];
  };

  // 保存数据
  const clickSave = (e: any) => {
    e.stopPropagation();
    props.clickSave(defaultStyle);
    setShowEdit(false);
    setShowHover(false);
    setSelectedIconBox("");
  };

  // 选中顶部图标功能
  const clickIcon = (key: string) => {
    const value = selectedIconBox !== key ? key : "";
    setSelectedIconBox(value);
  };

  // 顶部图标选中状态
  const getSelected = (key: string) => {
    return selectedIconBox === key ? style["selected-icon"] : "";
  };

  // 更换字体
  const clickFontFamily = (key: string) => {
    const data = Object.assign({}, defaultStyle, { fontFamily: key });
    setDefaultStyle(data);
  };

  // 选中字体状态
  const getSelectedFontFamily = (key: string) => {
    return defaultStyle.fontFamily === key ? style["selecting-family"] : "";
  };

  useEffect(() => {
    // 初始化样式保存数据
    setDefaultStyle(props.defaultStyle);
  }, [props.defaultStyle]);

  useEffect(() => {
    // 进入编辑状态，页面应该去掉溢出隐藏。
    if (showEdit && !showEditArrStore.includes(props.valueKey)) {
    }
  }, [showEdit]);

  useEffect(() => {
    setShowHover(props.isEdit);
    setShowEdit(props.isEdit);
  }, [props.isEdit]);

  if (props.isShare) return <></>;
  return (
    <div className={style["hover-box"]} onMouseLeave={onMouseLeave} onMouseOver={onMouseOver}>
      <div className={`${style["edit-box"]} ${hideAndDisplay(showHover)}`} onClick={clickEdit}>
        {/* 字体选择 */}
        {/* {
          selectedIconBox === 'fontFamily' ?
            <div className={style['fontFamily-box']}>
              {
                fontFamilyArr.map((x, index) => {
                  return (<div key={index} className={`${style['fonts-selecting-box']} ${getSelectedFontFamily(x)}`} onClick={() => clickFontFamily(x)}>
                    <div style={{'fontFamily': x}} className={style['example-box']}>Aa</div>
                    <div className={style['fonts-selecting-name']}>{x}</div>
                  </div>)
                })
              }
            </div>
          : null
        } */}
        {/* 顶部可选择按钮 */}
        {/* <div className={style['top-box']}>
          <div className={`${style['icon-box']} ${getSelected('fontFamily')}`} onClick={() => clickIcon('fontFamily')}>
            <img src={typeFaceIcon}></img>
          </div>
          <div className={style['interval']}></div>
          <div className={`${style['icon-box']} ${getSelected('fontSize')}`} onClick={() => clickIcon('fontSize')}>
            { parseFloat(defaultStyle.fontSize) }
          </div>
          <div className={style['interval']}></div>
          <div className={`${style['icon-box']} ${getSelected('textAlign')}`} onClick={() => clickIcon('textAlign')}>
            <img src={sortIcon}></img>
          </div>
        </div> */}

        {/* 右侧可选择按钮 */}
        <div className={style["right-box"]}>
          <div className={style["icon-button"]} onClick={clickSave}>
            <img src={`${settings.S3CDN}${settings.viewAssetsPath}checkMarkBlack.png`}></img>
          </div>
          <div className={style["icon-button"]} onClick={clickClose}>
            <img src={`${settings.S3CDN}${settings.viewAssetsPath}previewDelete2x.png`}></img>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomHover;
